import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  frontend: {},
  guide_code: 0,
  list_layout_style: 0,
  details_layout_style: 0,
  systemModuleList: [],
  languageDataSet: { key: '' },
  perDeplinkage: '',
  setSubformRefList: {},
  setSubformRelation: {},
  getSubformBatchUpdate: {},
  getPicklistDependnew: {},
  clearPicklistField: '',
  clearDepartmentData: {},
  reportMenuUpdate: '',
  multitextDrogCover: {},
  role: {},
  userInfo: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_FRONTEND](state, frontend) {
    state.frontend = frontend
  },
  [types.SET_FRONTEND_GUIDE_CODE](state, code) {
    state.guide_code = code
  },
  [types.SET_LISTLAYOUT_STYLE](state, data) {
    state.list_layout_style = data
  },
  [types.SET_DETAILSLAYOUT_STYLE](state, data) {
    state.details_layout_style = data
  },
  [types.SET_SYSTEM_MODEULE_LIST](state, data) {
    state.systemModuleList = data
  },
  [types.SET_LANGUAGE_DATA_SET](state, data) {
    state.languageDataSet = data
  },
  [types.PER_DEP_LINKAGE](state, data) {
    state.perDeplinkage = data
  },
  [types.SET_SUBFORM_REF_MAPPING](state, data) {
    state.setSubformRefList = data
  },
  [types.SET_SUBFORM_RELATION](state, data) {
    state.setSubformRelation = data
  },
  [types.SET_SUBFORM_BATCHUPDATE](state, data) {
    state.getSubformBatchUpdate = data
  },
  [types.SET_PICKLIST_DEPEND_NEW](state, data) {
    state.getPicklistDependnew = data
  },
  [types.SET_CLEAR_OICKLIST_FIELD](state, data) {
    state.clearPicklistField = data
  },
  [types.SET_CLEAR_DEPARTMENT_DATA](state, data) {
    state.clearDepartmentData = data
  },
  [types.SET_REPORT_MENU_UPDATE](state, data) {
    state.reportMenuUpdate = data
  },
  [types.MULTITEXT_SET_COVER](state, data) {
    state.multitextDrogCover = data
  },
  [types.SET_AUTH_BY_ROLE](state, data) {
    state.role = data
  },
  [types.SET_USER_INFO](state, data) {
    state.userInfo = data
  }
}
// getters getAuthByRole
const getters = {
  getFrontend: state => index => {
    // 当前编辑的字段
    return state.frontend
  },
  getFrontendGuideCode: state => () => {
    // 获取使用的布局
    return state.guide_code
  },
  getSystemModuleList: state => () => {
    // 基础模块
    return state.systemModuleList
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
